import { gql } from '@apollo/client';
const REMOVE_PRODUCT_PICTURE = gql `
  mutation RemoveProductPicture($productPictureId: ID!) {
    removeProductPicture(productPictureId: $productPictureId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_PICTURE;
